import * as React from 'react';
import {  computed, observable } from 'mobx';
import { observer } from 'mobx-react';
import NavDrawer from '../../component/NavDrawer/NavDrawer';
import { Switch, Redirect , NavLink, Route, withRouter, BrowserHistory } from "react-router-dom";
import { Drawer } from 'react-md';
import "./static/App.scss";
import { SVGIcon } from 'react-md';
import { IServicesProvider } from '../../di/IServicesProvider';
import OverviewView, { OverviewViewModel } from '../Admin/OverviewView/OverviewView';
import UsersView, { UsersViewModel } from '../Admin/UsersView/UsersView';
import ResultsView, { ResultsViewModel } from '../Admin/ResultsView/ResultsView';
import PushNotifications, { PushNotificaionsModel } from '../Admin/PushNotifications/PushNotifications';
import AccessManagementView, { AccessManagementModel } from '../Admin/AccessManagement/AccessManagement';
import PageNotFound from '../PageNotFound/PageNotFound';
import GuidesView, { GuidesViewModel } from '../Admin/GuidesView/GuidesView';
import OrganisationSurveys, { OrganisationSurveysModel } from "../Admin/OrganisationSurveys/OrganisationSurveys";

const MenuIcon = props => (
  <SVGIcon {...props}>
    <path d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z" />
  </SVGIcon>
);
export class AppModel {
  @observable drawerVisible = true;
  @observable headerTitle = "";
  @observable servicesProvider: IServicesProvider;
  constructor(servicesProvider: IServicesProvider) {
    this.servicesProvider = servicesProvider;
  }
  @computed get user() {
    return this.servicesProvider.getUser();
  }
    @computed get organisation() {
        return this.servicesProvider.getOrganisation();
    }
}

@observer
class App extends React.Component<{model: AppModel, match: {url: string}, history: BrowserHistory}, {}> {
  private overviewModel = new OverviewViewModel(this.props.model.servicesProvider);
  private isSurveyEnabled: boolean = this.props.model.organisation.code.startsWith("SSP") ||
      this.props.model.organisation.organisationSurveysEnabled;
  private usersModel =
  new UsersViewModel(this.props.model.servicesProvider,
                     this.props.model.user.organisation);
    private surveysModel =
         new OrganisationSurveysModel(this.props.model.servicesProvider);
  private resultsModel = new ResultsViewModel(this.props.model.servicesProvider,
                                              this.props.model.user.organisation);
  private pushNotificationsModel = new PushNotificaionsModel(this.props.model.servicesProvider);
  private accessManagementModel = new AccessManagementModel(this.props.model.servicesProvider);
  private adminGuidesModel = new GuidesViewModel();
  render() {
    const items = [
      {
        title: <NavLink key="Overview" className='nav-element' to="/admin/overview">Overview</NavLink>
      },
      {
        title: <NavLink key="Users" className='nav-element' to="/admin/users">Users</NavLink>
      },
      {
        title: <NavLink key="Results" className='nav-element' to="/admin/results">Results</NavLink>
      },
      {
        title:
        <NavLink key="Notifications" className='nav-element' to="/admin/notifications">Push Notifications</NavLink>
      },
        {
            title: <NavLink key="Access" className='nav-element' to="/admin/access">Access Management</NavLink>
        },
      {
        title: <NavLink key="Guides" className='nav-element' to="/admin/guides">Admin Guides</NavLink>
      }
    ];

    if (this.isSurveyEnabled) {
        let index = items.length > 1 ? items.length - 2 : 0;
        items.splice(index , 0, {
            title: <NavLink key="Surveys" className='nav-element' to="/admin/surveys">Surveys Management</NavLink>
        });
    }

    return (
      <div className="root">

        <div className="md-drawer-relative" >
         {
           (this.props.model.organisation.parent_id === "3" || this.props.model.organisation.parent_code === "SSP") &&
            <div className="header-alert">
                <h4><b>Important Update!</b> We are transferring the current portal to
                        <a href="https://saferschoolsportal.co.uk/" target="_blank"> saferschoolsportal.co.uk</a>&nbsp;
                            after 10 March 2021
                </h4>
            </div>
        }
        <div className="content-header">
        <MenuIcon
          className="hamburger"
          onClick={() =>  this.props.model.drawerVisible = !this.props.model.drawerVisible}
          size={34}
        />

        <h2> {this.props.model.headerTitle}</h2>
        </div>
        <Switch>
        <Route
          path={`${this.props.match.url}/overview`}
          render={(props) => {
            this.props.model.headerTitle = "Overview";
            return  <OverviewView model={this.overviewModel}/>;
                 }}
        />

        <Route
          path={`${this.props.match.url}/users`}
          render={(props) => {
            this.props.model.headerTitle = "Users";
            return  <UsersView model={this.usersModel}/>;
        }}
        />
        <Route
          path={`${this.props.match.url}/results`}
          render={(props) => {
            this.props.model.headerTitle = "Results";
            return  <ResultsView model={this.resultsModel}/>;
        }}
        />
        <Route
          path={`${this.props.match.url}/notifications`}
          render={(props) => {
            this.props.model.headerTitle = "Push Notifications";
            return  <PushNotifications model={this.pushNotificationsModel}/>;
        }}
        />
            { this.isSurveyEnabled &&
                <Route
                    path={`${this.props.match.url}/surveys`}
                    render={(props) => {
                        this.props.model.headerTitle = "Surveys Management Console";
                        return <OrganisationSurveys model={this.surveysModel}/>;
                    }}
                />
            }
        <Route
          path={`${this.props.match.url}/access`}
          render={(props) => {
            this.props.model.headerTitle = "Access Management";
            return  <AccessManagementView model={this.accessManagementModel}/>;
        }}
        />
        <Route
          path={`${this.props.match.url}/guides`}
          render={(props) => {
            this.props.model.headerTitle = "Admin Guides";
            return  <GuidesView model={this.adminGuidesModel} />;
        }}
        />

        <Redirect from={`${this.props.match.url}`} exact={true} to={`${this.props.match.url}/overview`} />
        <Route
          render={(props) =>
          <PageNotFound homeOnClick={() => this.props.history.push(`${this.props.match.url}/overview`)} />}

        />
        </Switch>

        </div>
        <Drawer
          desktopType={Drawer.DrawerTypes.PERSISTENT}
          defaultVisible={true}
          visible={this.props.model.drawerVisible}
          mobileType={Drawer.DrawerTypes.TEMPORARY}
          onVisibilityChange={(x) => this.props.model.drawerVisible = x}
          onMediaTypeChange={(type, media) => {
            if (type === Drawer.DrawerTypes.PERSISTENT) {
              this.props.model.drawerVisible = true;
            }
          }}
        >
        <NavDrawer
          items={items}
          user={this.props.model.user.name}
          organisationName={this.props.model.user.organisationName}
        />
        </Drawer>
      </div>
    );
  }
}

export default withRouter(App);



// WEBPACK FOOTER //
// ./src/view/App/App.tsx